import type OpenAI from 'openai'

// Industry-standard rough token estimates (no tiktoken dependency).
// English prose: ~4 chars/token. Code/JSON: ~3.5 chars/token.
// Per-message overhead: 4 tokens for role + framing; 2 tokens for reply primer.
// Accuracy: ±15–20% vs actual BPE tokenizer — sufficient for threshold guards
// and simulated cost estimates. Label any cost derived from this as "~$X (est.)".

const CHARS_PER_TOKEN = 4
const TOKENS_PER_MESSAGE_OVERHEAD = 4
const REPLY_PRIMER_TOKENS = 2

function messageContentChars(
  content: OpenAI.ChatCompletionMessageParam['content'],
): number {
  if (typeof content === 'string') return content.length
  if (Array.isArray(content)) {
    return content.reduce((sum, part) => {
      if ('text' in part && typeof part.text === 'string') {
        return sum + part.text.length
      }
      return sum
    }, 0)
  }
  return 0
}

export function estimateMessagesTokens(
  messages: OpenAI.ChatCompletionMessageParam[],
): number {
  const messageTokens = messages.reduce((sum, m) => {
    const contentTokens = Math.ceil(
      messageContentChars(m.content) / CHARS_PER_TOKEN,
    )
    return sum + TOKENS_PER_MESSAGE_OVERHEAD + contentTokens
  }, 0)
  return messageTokens + REPLY_PRIMER_TOKENS
}
